import axios from "axios";

export class ApiClient {
    private _basePath: string = "";
    constructor(basePath: string) {
        this._basePath = basePath;
    }

    public async get(path: string, query: object = {}, opts: { basePath?: string } = {}) {
        const { data } = await axios.get(`${opts.basePath || this._basePath}${path}`, { params: query });
        return data;
    }

    public async post(path: string, body: any = {}, query: object = {}, opts: { basePath?: string } = {}) {
        const { data } = await axios.post(`${opts.basePath || this._basePath}${path}`, body, { params: query });
        return data;
    }

    public async put(path: string, body: any = {}, query: object = {}, opts: { basePath?: string } = {}) {
        const { data } = await axios.put(`${opts.basePath || this._basePath}${path}`, body, { params: query });
        return data;
    }

    public async delete(path: string, query: object = {}, opts: { basePath?: string } = {}) {
        const { data } = await axios.delete(`${opts.basePath || this._basePath}${path}`, { params: query });
        return data;
    }
}
